import styles from "./About.module.css";
import perfil from "../../assets/perfil.png";
import CV from "../../assets/Guilherme-CV.pdf";

const About = () => {
  return (
    <section className={`section`} id="about">
      <h2 className="section__title">Sobre</h2>
      <p className="section__subtitle">Um pouco sobre mim </p>
      <div className={`${styles.about_container} container grid`}>
        <img src={perfil} alt="profile" />
        <div>
          <p>
            Eu sou Guilherme Siqueira, tenho 23 anos, sou apaixonado por
            tecnologias e desafios complexos desde a infância. Atualmente, sou
            estudante de Sistemas de Informação, buscando expandir meus
            conhecimentos nessa área de constante evolução.
            <br />
            <br />
            Minha jornada como programador teve início após um curso de Arduíno
            durante minha graduação em Engenharia Mecânica, onde descobri meu
            interesse por programação. A partir desse momento, fui cativado por
            esse mundo e decidi redirecionar minha carreira para essa área.
            <br />
            <br />
            Estou constantemente buscando aprimorar minhas habilidades e
            acompanhar as tendências do desenvolvimento Front End. Com minha
            formação em Sistemas de Informação e capacidade de resolver
            problemas complexos, estou pronto para enfrentar os desafios da
            programação.
          </p>
          <a href={CV} className="button button--flex" download="">
            Download CV <i className="uil uil-import"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
